<template>
    <div class="pricelist-portal py-5 main-content">
        <div v-if="loading">
            <div class="vh-100 d-flex justify-content-center align-items-center">
                <vue-loaders-ball-beat scale="2" color="black" />
            </div>
        </div>
        <div v-else>
            <div v-if="(customerInfo && user) || currentParam.err" class="container">
                <div class="pricelist-header">
                    <h1>Price List Portal: <span v-if="!currentParam.err" v-html="customerInfo.company"></span></h1>
                    <div v-if="currentParam.err" class="pricelist-error">
                        <div v-switch="currentParam.err">
                            <div v-case="'cID'">
                                <h3 style="color:#cd1b00;">CANNOT VERIFY ACCOUNT</h3>
                                <p>We are sorry, but we cannot verify {{ user.company }}'s price level.<br />Please contact Customer Service at (518) 861-0133 for resolution.</p>
                            </div>
                            <div v-case="'n'">
                                <h3 style="color:#cd1b00;">THIS IS FOR AUTHORIZED DISTRIBUTOR MEMBERS ONLY</h3>
                                <p>Currently you have not been authorized to download the net Distributor Price List. Please contact your Purchasing/Sourcing department for authorization. If you are an authorizing member of your organization, please contact PIP Customer Service at (518) 861-0133 with your account information for resolution.</p>
                            </div>
                        </div>
                        <div>
                            <div style="border-bottom:dotted 1px #ccc; margin-bottom:20px;"></div>

                            <div style="float:left; width:225px; text-align:left;">
                                <iframe width="560" height="315" src="https://www.youtube.com/embed/z9gObJ_aVE0?rel=0&amp;controls=0" frameborder="0" allowfullscreen></iframe>
                            </div>
                        </div>
                    </div>
                    <div v-else>
                        <h3>THANK YOU {{ user.f_name }} {{ user.l_name }}</h3>
                        <p>Your user account has been verified and your price list is ready for download.</p>
                    </div>

                    <div v-if="currentParam.download=='error'">
                        <div class="note">
                            <span>ERROR</span>
                            <p>Error downloading the file. Please try again</p>
                        </div>
                    </div>
                </div>

                <div  v-if="!currentParam.err">
                    <!-- download price list buttons -->
                    <div v-if="calender" class="pricelist-calendar">
                        <div>
                            <strong>CURRENT PRICE LIST
                                <span v-if="calender.priceLIST <= '20200515' && date >= '20200515' && date <= calender.priceEND"> + MAY ADDENDUM </span>
                                - EFFECTIVE  {{ calender.priceEFFECTIVE.substring(4,6)+"/"+calender.priceEFFECTIVE.substring(6,8)+"/"+ calender.priceEFFECTIVE.substring(0,4) }}
                            </strong>

                            <ul >
                                <li>This price list supersedes all others previously published</li>
                                <li>Protective Industrial Products (PIP®) sells only to authorized distributors</li>
                                <li>This price list features new Unit of Measure and Pricing columns based on customer feedback, please review with your pricing and data teams</li>

                                <!-- Check to see if we have the terms for this price list -->
                                <li v-if="checkFile('/archive/price-lists/PIP-Price-List-Effective-'+calender.priceLIST+'-TERMS.pdf')">By downloading this price list you are agreeing to the <a :href="'/archive/price-lists/PIP-Price-List-Effective-'+calender.priceLIST+'-TERMS.pdf'" target="_blank" style="color:#cd1b00;">Terms &amp; Conditions</a></li>
                            </ul>

                            <div class="pricelist-download-btns mt-2">
                                <button v-if="customerInfo.cust_id != 'PIPRETCO'" @click="downloadPriceList(false)" class="btn-round-red">DOWNLOAD PRICE LIST</button>
                                <button v-if="customerInfo.cust_id != 'PUMA'" @click="downloadMarkdownPriceList()" class="btn-round-red">DOWNLOAD CLOSEOUT PRICE LIST</button>
                                <button v-if="truckLoadProgram" @click="downloadTruckLoadPriceList()" class="btn-round-red">DOWNLOAD TRUCKLOAD PRICE LIST</button>
                            </div>
                        </div>

                        <div v-if="(date>=calender.pricingALERT || isAdminUser) && customerInfo.cust_id != 'PIPRETCO'">
                            <!-- are we in the price calendar alert window -->
                            <div v-if="calender.priceEFFECTIVENEXT != ''">

                                <strong>NEW PRICE LIST <span v-if="calender.priceLISTNEXT <= '20200515' && date >= '20200515' && date <= calender.priceENDNEXT">+ MAY ADDENDUM</span>
                                - EFFECTIVE {{ calender.priceEFFECTIVENEXT.substring(4,6) +"/"+calender.priceEFFECTIVENEXT.substring(6,8) +"/"+ calender.priceEFFECTIVENEXT.substring(0,4)}}</strong>

                                <div class="pricelist-download-btns mt-2">
                                    <button @click="downloadPriceList(true)" class="btn-round-red">DOWNLOAD PRICE LIST</button>
                                </div>
                            </div>
                            <div v-else>
                                <strong>NEW PRICE LIST ALERT - IN PROCESS</strong>
                                <div class="pricelist-download-btns mt-2">
                                    <button @click="downloadPriceList()" class="btn-round-red">DOWNLOAD PRICE LIST</button>
                                </div>
                            </div>
                        </div>
                    </div>

                    <!-- admin section -->
                    <div class="pricelist-userlist-header">
                        <div>
                            <h2 >
                                <span style="background:#fff; padding-right:5px;">{{customerInfo.company }} ADMIN SECTION</span>
                            </h2>
                        </div>

                        <div v-if="currentParam.alert">
                            <div v-switch="currentParam.alert">
                                <div v-case="'auth'">
                                    <div class="note"><span>SUCCESS! </span>
                                    <p>{{ currentParam.value }} has been granted authorization to download the price list and has been notified via email. If there is any error please contact support@pipusa.com for resolution.</p></div>
                                </div>
                                <div v-case="'add'">
                                    <div class="note">
                                        <span>SUCCESS!</span>
                                        <p>These colleagues have been granted authorization to download the price list and notified via email:</p>
                                        <section>
                                            <strong v-for="(email,index) in currentParam.value.split('|')" :key="index" ><span v-if="email">&bull; {{ email }}</span></strong>
                                        </section>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>


                    <div class="pricelist-userlist row">
                        <div class="col-sm-6">
                            <h4>AUTHORIZED USERS</h4>

                            <ul v-if="authorizedUserList.length > 0">
                                <li v-for="(aUser,authindex) in authorizedUserList" :key="authindex" >
                                    <span v-if="aUser.authUser">
                                        <span v-if="aUser.authUser.approved=='y'">
                                            <img src="/images/icons/icon-square-check.gif" width="15" height="15" alt="authorized user" style="position:relative; top:3px; margin-right:3px;" />
                                            {{ aUser.authUser.f_name+" "+aUser.authUser.l_name }} - {{ aUser.authUser.title }}

                                            <div style="font-size:9px; text-transform:uppercase; padding:3px 3px 3px 18px; border-bottom:dotted 1px #ccc;">
                                                AUTHORIZED BY:
                                                <span v-if="aUser.authBy == null">
                                                    PIP
                                                </span>
                                                <span v-else>
                                                    {{ aUser.authBy.f_name }} {{ aUser.authBy.l_name }}
                                                    <span v-if="aUser.authBy.company=='PIP'">FROM PIP</span>
                                                </span>
                                            </div>
                                        </span>

                                        <span v-else>
                                            <img src="/images/icons/icon-square-empty.gif" width="15" height="15" alt="pending user" style="position:relative; top:3px; margin-right:3px;" />
                                            {{ aUser.authUser.email}}
                                            <div style="font-size:9px; text-transform:uppercase; padding:3px 3px 3px 18px; border-bottom:dotted 1px #ccc;">
                                                AUTHORIZED BY:

                                                <span v-if="aUser.authBy == null">
                                                    PIP
                                                </span>
                                                <span v-else>
                                                    {{ aUser.authBy.f_name }} {{ aUser.authBy.l_name }}
                                                    <span v-if="aUser.authBy.company=='PIP'">FROM PIP</span>
                                                </span>

                                                <br />
                                                <strong style="color:#cd1b00;">
                                                    Pending Sign Up &amp; Verification
                                                </strong>
                                            </div>
                                        </span>
                                    </span>
                                </li>
                            </ul>

                            <p><em class="disclaimer">These are individuals that PIP or another authorized user at {{ user.company }} has granted authorization to download the price list. If you see a mistake in the list below, please contact Cory Dinon at (518) 595-1545.</em></p>
                        </div>

                        <div class="col-sm-6">
                            <section>
                                <h4 style="color:#666;">DOWNLOADED BY: <span >(Last 90 Days)</span></h4>

                                <div v-if="priceListDownload.length > 0" class="mb-4">
                                    <section v-for="(DLrow,index) in priceListDownload" :key="index">
                                        <div v-if="DLrow.user">
                                            <img src="/images/btn-arrow-down-grey.gif" width="13" height="13"  style="position:relative; top:3px; margin-right:3px;" />
                                                {{ DLrow.user.f_name }} {{ DLrow.user.l_name }} - {{ DLrow.user.title }}

                                            <div style="font-size:9px; text-transform:uppercase; padding:3px 3px 3px 16px; border-bottom:dotted 1px #ccc;">
                                                DOWNLOADED: {{ new Date(Date.UTC(parseInt(DLrow.timestamp.substr(0, 4)), parseInt(DLrow.timestamp.substr(4, 2)) - 1, parseInt(DLrow.timestamp.substr(6, 2)), parseInt(DLrow.timestamp.substr(8, 2)), parseInt(DLrow.timestamp.substr(10, 2)), parseInt(DLrow.timestamp.substr(12, 2)))).toLocaleString('en-US', {weekday: 'short', month: 'short', day: 'numeric', hour: 'numeric', minute: 'numeric', hour12: true, timeZone: 'UTC'}).toUpperCase() }}
                                            </div>
                                        </div>
                                    </section>
                                </div>
                                <div v-else>
                                    <p  style="color:#cd1b00;">This price list has not been downloaded by anyone at {{ user.company }}</p>
                                </div>
                            </section>

                            <section>
                                <h4 style="color:#666;">GRANT AUTHORIZATION TO COLLEAGUES: </h4>

                                <div v-if="unauthorizedUserList.length > 0">
                                    <ul>
                                        <li v-for="(unauthUser,index) in unauthorizedUserList" :key="index">
                                            <div class="d-flex flex-row align-items-center">
                                                <a href="javascript:void(0);" data-toggle="modal" :data-target="'#auth-user-'+unauthUser.id" class="mr-2">
                                                    <img src="/images/icons/admin-icon-add.gif" width="15" height="15" alt="grant authorization"  />
                                                </a>
                                                <span>{{ unauthUser.f_name }} {{ unauthUser.l_name }} - {{ unauthUser.title }}</span>
                                            </div>
                                            <!-- Grant User Permission to Download Pricelist Pop Up -->
                                            <modal :id="'auth-user-'+unauthUser.id" title="Authorize User to download Price List" @confirmFunction="authorizeUser(unauthUser)"> Do you want to authorize {{unauthUser.f_name}} {{ unauthUser.l_name }} to download price list ?</modal>

                                        </li>
                                    </ul>
                                </div>
                                <div v-else>
                                    <p style="color:#cd1b00;">Currently, there are no colleagues awaiting authorization.</p>
                                </div>

                                <p>
                                    <em class="disclaimer">
                                    These are your colleagues that have been verified by PIP to see "Distributor Only" content on the website, but have not been given authorization to download the price list. If you would like to grant them authorization click on the green plus icon next to their name.
                                    </em>
                                </p>
                            </section>

                            <section>
                                <h4 style="color:#666;" >ADD COLLEAGUES TO AUTHORIZED LIST</h4>
                                    <form method="post">
                                        <div v-for="index in 5" :key="index">
                                            <p>
                                                <input type="text" name="email[]" v-model="email[index]" class="inputValue" title="Enter Email Address" style="width:300px;"/>
                                            </p>
                                        </div>
                                        <button @click.prevent="addUserToAuth()" class="mt-4 btn-round-red">add to authorized users list</button>
                                    </form>
                                    <p>
                                    <em class="disclaimer">
                                    These are your colleagues that have been <strong style="color:#000;">NOT</strong> been verified by PIP to see "Distributor Only" content on the website. If you would like to grant them authorization to download the price list  please enter their email address in the spaces above.
                                    </em> </p>
                            </section>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

</template>

<script type="text/javascript">
import { mapState } from "vuex";

const ExcelJS = require('exceljs');

export default {
    data() {
        return {
            isAdminUser: false,
            loading:false,
            calender:null,
            customerInfo:null,
            truckLoadProgram:null,
            authorizedUserList:[],
            priceListDownload:[],
            unauthorizedUserList:[],
            errors:null,
            email:[],
        };
    },
    props: ['customerId'],
    computed: {
        ...mapState({
            user: state => state.user,
            priceAdmins: state => state.priceERPAdmins
        }),
        currentParam() {
            return this.$route.query;
        },
        checkCustID(){
            if((this.user.cust_id == "16874" || this.user.cust_id == "19431" || this.user.cust_id == "35198") && !this.currentParam.err){
                this.loading = false;
                this.$router.push({ query:{err: "cID" }});
                return true;
            }else{
                return false;
            }
        },
        date(){
            let dateObj = new Date();
            let year = dateObj.getFullYear();
            let month = String(dateObj.getMonth() + 1).padStart(2, '0');
            let day = String(dateObj.getDate()).padStart(2, '0');
            return year + month + day;
        },
    },
    created(){
        this.loading=true;
        const unwatch=this.$watch('user',()=>{

            if(this.customerId != null) { // Coming from dynamic price list
                this.getPriceListInformation(this.customerId);
            } else if(this.user){
                //check if the user has been assigned a customer ID
                if(this.user.cust_id){
                    this.getPriceListInformation(this.user.cust_id);
                }else{
                    this.$router.push({ query:{err: "n" }});
                }
            }else{
                this.$router.push({ path: "/PriceListVerify/"});
            }
            unwatch();
        });
    },
    methods: {
        getPriceListInformation(customerId) {
            // ##WHITECAP REDIRECT###################################
            if((customerId == "16874" || customerId == "19431" || customerId == "35198") && !this.currentParam.err){
                this.loading = false;
                this.$router.push({ query:{err: "cID" }});
                return;
            }else{
                // get customer info and making sure distributor is in the cust_info database
                try{
                    if(typeof customerId === 'string' && (customerId == "PIPRETCO" || customerId.includes("WC") || customerId == "PUMA")) {
                        axios.get(`/api/quickLinkCustomerInfo/${customerId}`).then(response => {
                            if(response.data) {
                                this.customerInfo=response.data;
                                this.additionalApiCalls(customerId);
                            } else {
                                this.loading = false;
                                this.$router.push({ query:{err: "cID" }});
                                return;
                            }
                        });
                    } else {
                        axios.get(`/api/customerInfo/${customerId}`).then(response => {
                            if(response.data){
                                this.customerInfo=response.data;
                                this.additionalApiCalls(customerId);
                            }else{
                                this.loading = false;
                                this.$router.push({ query:{err: "cID" }});
                                return;
                            }
                        });
                    }
                }catch (error) {
                    this.errors = error.response ;
                    this.loading = false;
                    this.$router.push({ query:{err: "cID" }});
                    return;
                }
            }
        },
        additionalApiCalls(customerId) {
            axios.post(`/api/prodPriceCalender`,this.customerInfo).then(response => {
                this.calender=response.data;
            });
            axios.get(`/api/customerTruckLoadProgram/${customerId}`).then(response => {
                this.truckLoadProgram=response.data[0];
            });
            axios.get(`/api/authorizedUserList/${customerId}`).then(response => {
                this.authorizedUserList=response.data;
            });
            axios.get(`/api/unauthorizedUserList/${customerId}`).then(response => {
                this.unauthorizedUserList=response.data
            });
            axios.get(`/api/priceListDownloadBack90/${customerId}`).then(response => {
                this.priceListDownload=response.data;
            });
            this.loading=false;
        },
        getTimestamp(){
            const now = new Date();
            const year = now.getFullYear().toString().padStart(4, '0');
            const month = (now.getMonth() + 1).toString().padStart(2, '0');
            const day = now.getDate().toString().padStart(2, '0');
            const hour = now.getHours().toString().padStart(2, '0');
            const minute = now.getMinutes().toString().padStart(2, '0');
            const second = now.getSeconds().toString().padStart(2, '0');
            const currentDateTime = `${year}${month}${day}${hour}${minute}${second}`;
            return currentDateTime;
        },
        checkFile(path){
            fetch(path)
                .then(response => {
                    if (response.ok) {
                        return true;
                    } else {
                        return false;
                    }
                })
                .catch(error => {
                    // console.error(error);
                    return false;
                });
        },
        addUserToAuth(){
            this.loading=false;
            let data={
                "custID": this.user.cust_id,
                "refID": this.user.id,
                "email": this.email
            }

            //insert user info into the pricelist_auth table
            axios.post(`/api/storeUserToPriceListAuth`,data).then(response => {
                if(response.data){
                    this.$router.push({ query:{alert: "add", value: response.data }});
                    this.email=[];
                    // reload the list of authorized user list
                    axios.get(`/api/authorizedUserList/${this.user.cust_id}`).then(response => {
                        this.authorizedUserList=response.data;
                        this.loading=false;
                    });
                }else{
                    this.email=[];
                    this.loading=false;
                }
            });
        },
        generateExcel(dataArray,fileName,customerId){
            const workbook = new ExcelJS.Workbook();
            const worksheet = workbook.addWorksheet('My Sheet');
            dataArray.forEach((row) => worksheet.addRow(row));

            workbook.xlsx.writeBuffer()
            .then((buffer) => {
                const blob = new Blob([buffer], { type: 'application/octet-stream' });
                const link = document.createElement('a');
                link.href = URL.createObjectURL(blob);
                link.download = fileName;
                link.click();
                this.loading=false;
            });

            if(customerId == "WC") {
                customerId = this.customerInfo.cust_id + "-" + this.customerInfo.price_level;
            }
            axios.get(`/api/priceListDownloadBack90/${customerId}`).then(response => {
                this.priceListDownload=response.data;
            });
        },
        downloadPriceList(newList){
            this.loading=true;
            let data={
                "truckLoad":0,
                "markDown":0,
                "customerInfo":this.customerInfo,
                "priceListCalender":this.calender,
                "userID":this.user.id,
                "newList": newList
            };
            let fileName="PriceList-"+this.customerInfo.cust_id+"-"+this.getTimestamp()+".xlsx";
            axios.post('/api/downloadPriceList', data, { responseType: 'blob' })
                .then(res => {
                    const blob = new Blob([res.data]);
                    const url = window.URL.createObjectURL(blob);

                    const a = document.createElement('a');
                    a.href = url;
                    a.download = fileName.replace('.xlsx', '.csv');
                    document.body.appendChild(a);
                    a.click();
                    a.remove();

                    window.URL.revokeObjectURL(url);
                })
                .catch(err => console.log(err))
                .finally(() => { this.loading = false; });
        },
        downloadMarkdownPriceList(){
            this.loading=true;
            let data={
                "truckLoad":0,
                "markDown":1,
                "customerInfo":this.customerInfo,
                "priceListCalender":this.calender,
                "userID":this.user.id,
                "newList": false
            };

            let fileName="PriceList-Markdown-"+this.customerInfo.cust_id+"-"+this.getTimestamp()+".xlsx";
            axios.post('/api/downloadPriceList', data, { responseType: 'blob' })
                .then(res => {
                    const blob = new Blob([res.data]);
                    const url = window.URL.createObjectURL(blob);

                    const a = document.createElement('a');
                    a.href = url;
                    a.download = fileName.replace('.xlsx', '.csv');
                    document.body.appendChild(a);
                    a.click();
                    a.remove();

                    window.URL.revokeObjectURL(url);
                })
                .catch(err => console.log(err))
                .finally(() => { this.loading = false; });
        },
        downloadTruckLoadPriceList(){
            this.loading=true;
            let data={
                "truckLoad":1,
                "markDown":0,
                "customerInfo":this.customerInfo,
                "priceListCalender":this.calender,
                "truckLoadProgramCustID":this.truckLoadProgram["cust_id"],
                "userID":this.user.id,
                "newList": false
            };
            let fileName="PriceList-TruckLoad-"+this.customerInfo.cust_id+"-"+this.getTimestamp()+".xlsx";
            axios.post('/api/downloadPriceList', data, { responseType: 'blob' })
                .then(res => {
                    const blob = new Blob([res.data]);
                    const url = window.URL.createObjectURL(blob);

                    const a = document.createElement('a');
                    a.href = url;
                    a.download = fileName.replace('.xlsx', '.csv');
                    document.body.appendChild(a);
                    a.click();
                    a.remove();

                    window.URL.revokeObjectURL(url);
                })
                .catch(err => console.log(err))
                .finally(() => { this.loading = false; });
        },
        authorizeUser(user){
            this.loading=true;
            window.scrollTo(0, 0);
            let data={
                'user':user,
                'authBy':this.user.id
            };

            // remove popup
            $("#auth-user-"+user.id).modal('hide');

            //authorize user to download price list
            axios.post(`/api/authorizeUser`,data).then(response => {
                if(response.data){
                    this.loading=false;
                    this.$router.push({ query:{alert: "auth", value: user.f_name+' '+user.l_name }});
                }

                // update authorized user list
                axios.get(`/api/authorizedUserList/${this.user.cust_id}`).then(response => {
                    this.authorizedUserList=response.data;

                });

                // update
                axios.get(`/api/unauthorizedUserList/${this.user.cust_id}`).then(response => {
                    this.unauthorizedUserList=response.data
                });
            });
        },
    },
    watch:{
        calender: function(newVal){
            this.calender=newVal;
        },
        truckLoadProgram: function(newVal){
            this.truckLoadProgram=newVal;
        },
        user() {
            this.isAdminUser = this.priceAdmins.includes(this.user.id);
        }
    },
};
</script>

<style scoped>
    .container {
        max-width: 100%;
    }
</style>
